import { RenderEngine } from "../../../Controller/3DController/core/RenderEngine";


export interface ICaptureToolCamera {
  position:number[],
  target:number[],
  transitionTime:number,
  transitionEasing:string
}

// TODO: Track running animation and timeout to next animation step to allow aborting later on


export class CaptureToolCameraManager {
  public cameras:ICaptureToolCamera[];
  public selectedCamera:ICaptureToolCamera;
  public renderEngine:RenderEngine;
  public onUpdate:Function;

  public animationActive:boolean = false;
  public animationTimeout:number = null;

  constructor(renderEngine:RenderEngine, onCameraUpdate:Function) {
    this.cameras = [];
    this.renderEngine = renderEngine;
    this.onUpdate = onCameraUpdate;
  }

  public changeSelectedCamera = (camera:ICaptureToolCamera) => {
    this.selectedCamera = camera;
    this._updateSceneCameraPosition(camera);
    this.onUpdate();
  }

  public createNewCamera = () => {
    const { cameraController } = this.renderEngine.engine.services.render;
    const newCamera:ICaptureToolCamera = {
      position: this.getCurrentSceneCameraPosition(),
      target: cameraController.cameraProperties.target,
      transitionTime: 1000,
      transitionEasing: "linear"
    };
    newCamera.position = newCamera.position.map((v) => Number(v.toFixed(3)));
    this.cameras.push(newCamera);
    this.onUpdate();
  }

  public deleteCamera = (camera:ICaptureToolCamera) => {
    this.cameras = this.cameras.filter((c) => c !== camera);
    this.onUpdate();
  }

  public changeCameraPosition = (camera:ICaptureToolCamera, value:number[]) => {
    value.map((v) => Number(v.toFixed(3)));
    camera.position = value;
    if (camera === this.selectedCamera) this._updateSceneCameraPosition(camera);
    this.onUpdate();
  }

  public changeCameraTransitionTime = (camera:ICaptureToolCamera, value:number) => {
    camera.transitionTime = value;
    this.onUpdate();
  }

  public changeCameraTransitionEasing = (camera:ICaptureToolCamera, value:string) => {
    camera.transitionEasing = value;
    this.onUpdate();
  }

  public getCurrentSceneCameraPosition = ():number[] => {
    const { cameraController } = this.renderEngine.engine.services.render;
    let currentCameraPosition = [cameraController.cameraPosition.x, cameraController.cameraPosition.y, cameraController.cameraPosition.z];
    currentCameraPosition = currentCameraPosition.map((v) => Number(v.toFixed(3)));
    return currentCameraPosition;
  }

  public playAnimation = () => {
    const { cameraController } = this.renderEngine.engine.services.render;

    this.animationActive = true;
    this.animationTimeout = null;
    this.onUpdate();

    const playAnimationStep = (index:number) => {
      if (index > this.cameras.length-1) {
        console.log(`Animation finished!`);
        this.animationActive = false;
        this.animationTimeout = null;
        this.onUpdate();
        return;
      };

      console.log(`Animation now transitioning to camera ${index}!`);
      const camera = this.cameras[index];
      const transitionTime = index === 0 ? 0 : camera.transitionTime;

      const cameraProperties = cameraController.cameraProperties;
      cameraProperties.position = camera.position;

      cameraController.setOrbitCamera(cameraProperties, { time: transitionTime, easing: camera.transitionEasing, onFinished: (reason:string) => {
        this.animationTimeout = window.setTimeout(() => {
          if (reason === 'finished') playAnimationStep(index+1);
        }, 0); //Weird behavior without window.setTimeout -> discuss with Lorenz? Seems to happen because cameraController._runningAnimationFinished() (= onFinished()) is overwritten "at the wrong time"... ?
      }});
    }

    playAnimationStep(0);
  }

  public stopAnimation = () => {
    const { cameraController } = this.renderEngine.engine.services.render;
    const cameraProperties = cameraController.cameraProperties;
    cameraProperties.position = this.cameras[0].position;
    cameraController.setOrbitCamera(cameraProperties, { time: 1, onFinished: ()=>null  });
    this.animationActive = false;
    this.animationTimeout = null;
    this.onUpdate();
  }

  private _updateSceneCameraPosition = (camera:ICaptureToolCamera) => {
    const { cameraController } = this.renderEngine.engine.services.render;
    const cameraProperties = cameraController.cameraProperties;
    cameraProperties.position = camera.position;
    cameraController.setOrbitCamera(cameraProperties);
  }
}